module.exports = __webpack_public_path__ + "static/media/star_disbled_icon.236b84a1.svg";